<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
  <p class="file-to-move">
    <strong>Moving:</strong> {{ data.fileToMove }}
  </p>

  <div class="folder-tree">
    <div class="folder-item"
         *ngFor="let folder of flattenedFolders"
         [class.selected]="selectedFolder === folder.path"
         [class.disabled]="isCurrentFolder(folder.path)"
         [style.padding-left.px]="folder.level * 24">

      <div class="folder-row" (click)="!isCurrentFolder(folder.path) && selectFolder(folder.path)">
        <!-- Expand/Collapse button -->
        <button mat-icon-button
                *ngIf="folder.hasChildren"
                (click)="toggleFolder(folder.path); $event.stopPropagation()"
                class="expand-button">
          <mat-icon>{{ folder.isExpanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
        </button>
        <span *ngIf="!folder.hasChildren" class="no-expand-spacer"></span>

        <!-- Folder icon and name -->
        <mat-icon class="folder-icon">folder</mat-icon>
        <span class="folder-name" [title]="getDisplayPath(folder.path)">
          {{ folder.name }}
          <span class="current-indicator" *ngIf="isCurrentFolder(folder.path)">(current location)</span>
        </span>
      </div>
    </div>
  </div>

  <div class="selected-path" *ngIf="selectedFolder !== null">
    <strong>Selected destination:</strong> {{ getDisplayPath(selectedFolder) }}
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button
          color="primary"
          (click)="onConfirm()"
          [disabled]="selectedFolder === null || selectedFolder === data.currentPath">
    Move Here
  </button>
</mat-dialog-actions>